import moment from 'moment';

const xl = require("excel4node");
const NUMBERFORMAT= 'dd/mm/yyyy'
export const generatexlx = async (
  data: Array<any>,
  dataAskedinPosition: Array<string>,
  worksheetTitle: string
) => {
  let response: any;
  if (Array.isArray(data) && data.length > 0) {
    const wb = new xl.Workbook({
      dateFormat: 'yyyy/mm/dd',
    });
    const options = {
      margins: {
        left: 1.5,
        right: 1.5,
      },
    };
    const ws = wb.addWorksheet(worksheetTitle, options);
    createHeaders(dataAskedinPosition, ws).then((_ok) => {
      return;
    });
    ws.row(1).filter({
      firstRow: 2,
      firstColumn: 1,
      lastRow: data.length + 1,
      lastColumn: dataAskedinPosition.length,
    });
    await addData(data, dataAskedinPosition, ws).then(async (_ok) => {
      // write the buffer in response
      await wb.writeToBuffer().then((buffer: Buffer) => {
        response = buffer;
      });
    });
  } else {
    throw new Error("Failed to generate excel");
  }
  return response;
};

const checkCountry = (inp: any) => {
  return inp === "countryid"
}

const insert = (arr: any[], index: any, newItem: any) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index)
]

const findTheIndex = ( arr: any[], inp: any ) => {
  return  arr.findIndex(inp) + 1;
}

const addDashAndBreakline = ( arr: any[], header: string) => {
  if(arr.length > 1) {
    return arr.map((item: string) => `- ${item}`).join("\n")
  } else {
    if(dashedColumnsArray.includes(header)){
      return arr.map((item: string) => `${item}`);
    } else {
      return arr[0];
    }
  }
}

const removeCarets = ( inp: any ) => {
  if(inp.includes("^^^")){
    return inp.split("^^^").map((item: string) => `- ${item}`).join("\n")
  }
  return inp;
}


const datesArray = [
  "applicationdate",
  "grantdate",
  "pubgrantdate",
  "pubapplicationdate",
  "renewalregistration",
  "varietyinsertdate",
  "denominationinsertdate"
]

const extraDatesArray = [
  "var_status_date",
  "all_contributions"
]

const dashedColumnsArray = [
  "other_bot",
  "en",
  "fr",
  "de",
  "es"
]

export const addData = async (
  data: Array<any>,
  columns: Array<string>,
  ws: any
) => {
  let filteredColumns: any[] = [];
  if(columns.includes("countryid") && columns.includes("denomination")){
    const countryIndex = findTheIndex(columns, checkCountry);
    filteredColumns = insert(columns, countryIndex, "countryname");
  } else {
    filteredColumns = columns;
  }
  let startingRow = 2;
  data.forEach((row) => {
    const keys = Object.keys(row);
    keys.forEach((key: string) => {
      let keyIndex = filteredColumns.findIndex((_key) => _key === key);
      keyIndex++;
      if (keyIndex > 0) {
        if (datesArray.includes(key)){
          const date = moment.utc(row[key],'YYYYMMDD',true);
          if(date.isValid()){
            ws.cell(startingRow, keyIndex).date(date).style({ numberFormat: NUMBERFORMAT})
          }
        } else if (extraDatesArray.includes(key)){
          const date = moment(row[key], 'YYYY-MM-DDTHH:mm:ssZ', true);
          if(date.isValid()){
            ws.cell(startingRow, keyIndex).date(date).style({ numberFormat: NUMBERFORMAT})
          }
        } else if (key === "test_date") {
          const date = moment(row[key]);
          if(date.isValid()){
            ws.cell(startingRow, keyIndex).date(date).style({ numberFormat: NUMBERFORMAT})
          }
        } else if (typeof row[key] === "string") {
          ws.cell(startingRow, keyIndex).string(removeCarets(row[key]));
        } else if (row[key] === null) {
          ws.cell(startingRow, keyIndex).string('');
        } else if (typeof row[key] === "object") {
          ws.cell(startingRow, keyIndex).string(addDashAndBreakline(row[key], key));
        } else {
          ws.cell(startingRow, keyIndex).string(JSON.stringify(row[key]));
        }
      }
    });
    startingRow++;
  });

  return ws;
};

// @ts-ignore
const dataHeaderConv = (dataHeader: string) => ({
  "denomination": "Denomination",
  "countryid": "Country",
  "countryname": "Country name",
  "denominationnature": "Denomination nature",
  "specielatinname" : "Species latin name",
  "applicationstatus": "Variety status",
  "publicationtype": "Register type",
  "breederreference": "Breeder‘s reference",
  "breedername": "Breeder",
  "otherparty": "Other parties",
  "applicationnumber": "Application number",
  "applicationdate": "Application date",
  "pubapplicationdate": "Application published on",
  "grantnumber": "Grant/registration number",
  "grantdate": "Grant/registration date",
  "pubgrantdate": "Grant/registration published on",
  "renewalregistration": "Renewal on",
  "varietyinsertdate": "Variety insert date",
  "denominationinsertdate": "Denomination insert date",
  "specieclasscodes": "Species class",
  "specieclasses": "Class name",
  "cropsectors": "Crop sector",
  "classid":"Species Code",
  "princ_bot": "Principal botanical name",
  "other_bot": "Other botanical name(s)",
  "en": "English",
  "fr": "French",
  "de": "German",
  "es": "Spanish",
  "crop_sector": "Crop sector",
  "upovclass": "Class",
  "classname": "Class name",
  "info": "Remark",
  "species_id": "Species code",
  "description": "Description",
  "maintainername": "Maintainer",
  "applicantname": "Applicant",
  "holdername": "Holder",
  "pubproposaldate": "Denomination published on",
  "approvaldate": "Denomination approved on",
  "speciesid": "Species code",
  "futureexpirationdate": "Future expiration date",
  "publicationextraid": "Publication extra ID",
  "register_name": "Register name",
  "denominationstatus": "Denomination status",
  "denominationtype": "Denomination type",
  "species_name_en": "Species English name",
  "extra_data_url": "Extra data url",
  "remark": "Remarks",
  "deno_end_date": "Denomination end date",
  "enddate": "Expiration actual",
  "proposaldate": "Denomination proposed on",
  "apl_nb": "Application number",
  "var_status_date": "Date",
  "score": "Score",
  "var_status": "Variety status",
  "species_latin_name": "Species latin name",
  "breeder_name": "Breeder's name",
  "brd_name": "Breeder's name",
  "breeder_ref": "Breeder‘s reference",
  "brd_ref": "Breeder‘s reference",
  "country": "Country",
  "register_type": "Register type",
  "speciename": "Species latin name",
  "deno_status": "Denomination status",
  "testid": "Test ID",
  "species_name": "Species Latin Name",
  "test_date": "Test Date",
  "batch_name": "Batch Name",
  "advice": "Advice",
  "test_status": "Status",
  "register": "Register",
  "applicant": "Applicant",
  "title_holder": "Holder",
  "maintainer": "Maintainer",
  "class_data": "Class",
  "crop_sectors": "Crop sector",
  "name": "Organization",
  "publicationname": "Register Name",
  "publicationtypeid": "Register Type",
  "all_contributions": "Last Contribution",
  "outcomestatus": "Outcome",
  "article": "Article",
  "title": "Title",
  "jurisprudenceid": "Juris",
  "decisiondate": "Decision Date",
  "specieid": "Species"
})[dataHeader]

export const createHeaders = async (headers: Array<any>, sheet: any) => {
  let currentCol = 1;
  let filteredHeaders: any[] = [];

  if(headers.includes("countryid") && headers.includes("denomination")){
      const countryIndex = findTheIndex(headers, checkCountry);
      filteredHeaders = insert(headers, countryIndex, "countryname");
  } else {
    filteredHeaders = headers;
  }

  filteredHeaders.forEach((dataHeader) => {
      sheet.cell(1, currentCol).string(dataHeaderConv(dataHeader));
      currentCol++;
  });
};
